export default function FormHelperText() {
    return {
        MuiFormHelperText: {
            defaultProps: {
                component: "div",
            },
            styleOverrides: {
                root: {
                    marginTop: 4,
                    marginRight: 0,
                    marginLeft: 0,
                },
            },
        },
    };
}
